import { Location } from '@/features/shared/models/Location';

// Coarse "near which quay" tagging only. At ferry transit speed (~5-10 m/s)
// a 15 s refresh is ~75-150 m drift and ~0 m at a quay, while capping
// continuous-GPS battery drain.
const REFRESH_INTERVAL_MS = 15000;

let watchId: number | null = null;
let lastLocation: Location | null = null;
let lastStoredAt = 0;

export function startWatchingPosition(): void {
    if (watchId !== null || !('geolocation' in navigator)) {
        return;
    }

    watchId = navigator.geolocation.watchPosition(
        position => {
            const now = Date.now();
            if (lastLocation !== null && now - lastStoredAt < REFRESH_INTERVAL_MS) {
                return;
            }
            lastStoredAt = now;
            lastLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        },
        () => {
            // Keep the last known location on error; offshore the fix can drop out.
        },
        { enableHighAccuracy: true, maximumAge: REFRESH_INTERVAL_MS, timeout: 27000 }
    );
}

export function stopWatchingPosition(): void {
    if (watchId !== null) {
        navigator.geolocation.clearWatch(watchId);
        watchId = null;
    }
    lastStoredAt = 0;
    lastLocation = null;
}

export function getLastKnownLocation(): Location | null {
    return lastLocation;
}
